import { Button, Typography } from '@mui/material';

import { useTranslate } from '@/hooks/useTranslate';

import { openRepublicSuperApp } from '@/utils/superApp';

import {
  ApprovedDrawerContainer,
  ApprovedImg,
  StyledApprovedDrawer,
} from './Drawers.styled';

export function RemediationThankYouDrawer() {
  const { t } = useTranslate();

  return (
    <StyledApprovedDrawer open anchor="bottom" hideBackdrop={false}>
      <ApprovedDrawerContainer>
        <ApprovedImg />
        <Typography variant="headlineH3" textAlign="center" mb={1}>
          {t('moreInfo.remediationThankYouDrawer.title')}
        </Typography>

        <Typography variant="bodyB2Regular" textAlign="center" mb={3}>
          {t('moreInfo.remediationThankYouDrawer.body')}
        </Typography>

        <Button onClick={openRepublicSuperApp} fullWidth>
          {t('moreInfo.remediationThankYouDrawer.button.goToAccount')}
        </Button>
      </ApprovedDrawerContainer>
    </StyledApprovedDrawer>
  );
}
